import type {
  ActionToastProps as ActionToastType,
  LinkToastProps as LinkToastType,
  SurveyToastProps as SurveyToastType,
  Toast,
} from './types';

/** Type guard: identifies toasts that wrap a navigation link rendered as `<LinkToast>`. */
export function isLinkToast(toast: Toast): toast is LinkToastType {
  return (toast as LinkToastType).link !== undefined;
}

/** Type guard: identifies toasts that carry an inline action button rendered as `<ActionToast>`. */
export function isActionToast(toast: Toast): toast is ActionToastType {
  return (toast as ActionToastType).action !== undefined;
}

/** Type guard: identifies toasts that host a PostHog survey rendered as `<SurveyToast>`. */
export function isSurveyToast(toast: Toast): toast is SurveyToastType {
  return toast.type === 'survey';
}
